import hoverintent from 'hoverintent';

const expandedCSSClass = 'is-expanded';
const jsDropdownContainerClass = '.js-dropdown-container';

function isTargetDropdown(target) {
    const $el = $(target);
    return $el.hasClass('js-dropdown-toggle') || $el.closest(jsDropdownContainerClass).length > 0;
}

/**
 * Add Javascript functionality to all drop downs on the page
 * @param {object} component    The component for which dropdownSupport us being added
 * @param {string} selectorRoot The root of the dropdown selector
 * @returns {undefined} Returns nothing
 */
export default function addDropdownSupport(component, selectorRoot) {
    // Add support for showing/hiding dropdown when tabbed into
    $(`${selectorRoot} .c-utility-toggle__a`).on('focus', (e) => {
        $(`${selectorRoot} .js-dropdown-container`).addClass(expandedCSSClass);
    });

    $(`${selectorRoot} .c-utility-toggle__a`).on('blur', (e) => {
        $(`${selectorRoot} .js-dropdown-container`).removeClass(expandedCSSClass);
    });

    const $doc = $(document);
    const deviceCharacteristics = component.getDeviceCharacteristics();
    const isDesktop = !deviceCharacteristics.is_smallish && !deviceCharacteristics.is_medium;

    $(`${selectorRoot} .js-dropdown-toggle`).each((i, elem) => {
        $doc.off('click', '.js-dropdown-toggle');

        $doc.on('click', '.js-dropdown-toggle', (e) => {
            e.preventDefault();

            if (isDesktop) {
                $doc.on('click.outsideDropdown', (e2) => {
                    if (!isTargetDropdown(e2.target)) {
                        $doc.off('click.outsideDropdown');
                        $(jsDropdownContainerClass).removeClass(expandedCSSClass);
                    }
                });
            }

            const $dropDownContainer = $(e.currentTarget).closest(jsDropdownContainerClass);
            $dropDownContainer.toggleClass(expandedCSSClass);
        });
    });

    if (isDesktop) {
        $(`${selectorRoot} .js-dropdown-toggle-hover`).each((i, elem) => {
            const dropDownElement = $(elem).children(jsDropdownContainerClass);
            $(elem).off('hover');
            hoverintent(elem,
                function hoverOver(e) {
                    e.stopImmediatePropagation();
                    dropDownElement.addClass(expandedCSSClass);
                    const dropdownData = _.get(dropDownElement, 'context.dataset.dropdownToggle', '');
                    if (dropdownData === 'utility-currency') {
                        document.dispatchEvent(new CustomEvent('a15-currency-toggle-hover'));
                    }
                },
                function hoverOut(e) {
                    e.stopImmediatePropagation();
                    dropDownElement.removeClass(expandedCSSClass);
                }
            );
        });
    }
}
